import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../feathers.service'
import { from, Observable } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

export interface MyPermission {
  allocationId: number
  permissions: {
    id: number
    name: string
    description: string
    createdAt: string // ISO date string format
    updatedAt: string // ISO date string format
  }[]
}

@Injectable({
  providedIn: 'root',
})
export class MyPermissionService {
  private feathersService = inject(FeathersService)

  private readonly service = 'features/my-permissions'

  get(): Observable<MyPermission[]> {
    const service = this.feathersService.service(this.service)
    return from(service.find()).pipe(
      map((response: any) => {
        console.log('Service response:', response)
        return response.data || response
      }),
      catchError((error) => {
        console.error('Error in MyPermissionService:', error)
        throw error
      }),
    )
  }
}
